// CSV Export Utility Functions

export const exportToCSV = (data, filename) => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  // Get headers from first object
  const headers = Object.keys(data[0]);
  
  // Create CSV content
  const csvContent = [
    headers.join(','), // Header row
    ...data.map(row => 
      headers.map(header => {
        const value = row[header];
        // Handle values that contain commas or quotes
        if (value === null || value === undefined) return '';
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      }).join(',')
    )
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const prepareFinancialDataForExport = (financialReport) => {
  if (!financialReport) return [];
  
  const data = [];
  
  // P&L Summary
  if (financialReport.profit) {
    data.push({
      Category: 'Revenue',
      Subcategory: 'Total Revenue',
      Amount: financialReport.revenue?.total || 0,
      Details: 'Booking Revenue'
    });
    
    data.push({
      Category: 'Costs',
      Subcategory: 'Staff Costs',
      Amount: financialReport.costs?.staff_costs || 0,
      Details: `${financialReport.costs?.shifts_count || 0} shifts`
    });
    
    data.push({
      Category: 'Costs',
      Subcategory: 'Material Costs',
      Amount: financialReport.costs?.consumable_costs || 0,
      Details: `${financialReport.costs?.consumables_count || 0} consumable logs`
    });
    
    data.push({
      Category: 'Costs',
      Subcategory: 'Total Costs',
      Amount: financialReport.costs?.total || 0,
      Details: ''
    });
    
    data.push({
      Category: 'Profit',
      Subcategory: 'Net Profit',
      Amount: financialReport.profit?.net || 0,
      Details: `${financialReport.profit?.margin_percent?.toFixed(1) || 0}% margin`
    });
  }
  
  // Attendance Summary
  if (financialReport.summary) {
    data.push({
      Category: 'Attendance',
      Subcategory: 'Total Capacity',
      Amount: financialReport.summary.total_capacity || 0,
      Details: ''
    });
    
    data.push({
      Category: 'Attendance',
      Subcategory: 'Total Booked',
      Amount: financialReport.summary.total_booked || 0,
      Details: ''
    });
    
    data.push({
      Category: 'Attendance',
      Subcategory: 'Ghost Slots',
      Amount: financialReport.summary.total_ghost_slots || 0,
      Details: 'Revenue opportunity'
    });
    
    data.push({
      Category: 'Attendance',
      Subcategory: 'Utilization',
      Amount: financialReport.summary.average_utilization_percent || 0,
      Details: 'Percentage'
    });
  }
  
  return data;
};

export const prepareChildrenDataForExport = (children) => {
  return children.map(child => ({
    Name: `${child.first_name} ${child.last_name}`,
    'Age Group': child.age_group,
    'Date of Birth': new Date(child.date_of_birth).toLocaleDateString(),
    'Registered Date': new Date(child.created_at).toLocaleDateString(),
    'Parent ID': child.parent_id
  }));
};

export const prepareBookingsDataForExport = (bookings) => {
  return bookings.map(booking => ({
    Child: booking.child_name || 'Unknown',
    Session: booking.session_name,
    Date: new Date(booking.session_date).toLocaleDateString(),
    Time: `${booking.start_time} - ${booking.end_time}`,
    Price: `£${booking.price?.toFixed(2) || '0.00'}`,
    Status: booking.status,
    'Booked Date': new Date(booking.created_at).toLocaleDateString()
  }));
};

export const prepareLearningReportsForExport = (reports) => {
  return reports.map(report => ({
    Child: report.child_name,
    'Period Start': new Date(report.period_start).toLocaleDateString(),
    'Period End': new Date(report.period_end).toLocaleDateString(),
    Summary: report.summary || '',
    'Next Steps': report.next_steps || '',
    'Created Date': new Date(report.created_at).toLocaleDateString()
  }));
};
